<template>
  <div class="background-navbar-forms">
    <div class="header_forms_for_users">
      <img src="@/assets/photo/psy-kokh-no-bg.png" alt="logotype">
    </div>
  </div>
</template>
<script>
</script>